<template>
    <div class="o-main-category-menu main-category-menu">
        <div
            class="m-header__line"
            v-if="isShowBlueLine"
        />
        <button
            type="button"
            role="button"
            class="main-category-menu__button"
            v-for="(category, index) in mergedData"
            :key="index"
            :aria-label="`${ariaLabel}${category}`"
            @click="handleClick(category)"
        >
            <svg-icon
                v-if="category.icon"
                original
                :name="`${category.icon}`"
                class="main-category-menu__icon"
            />
            <svg-icon
                v-else
                original
                :name="`icons/${category.name}`"
                class="main-category-menu__icon"
            />
            <span class="main-category-menu__wrapper">
                <span class="main-category-menu__title">
                    {{ $t(`ui.${category.name}-category`) }}
                </span>
                <span 
                    v-if="category.description !== false"
                    class="main-category-menu__subtitle"
                >
                    {{ $t(`ui.${category.name}-category.description`) }}
                </span>
            </span>
            <svg-icon
                original
                name="icons/plus_mobile"
                class="main-category-menu__plus-icon"
            />
        </button>
    </div>
</template>

<script>

export default {
    name: 'OMainCategoryMenu',
    props: {
        extras: {
            type: Array,
            default: null
        },
        ariaLabel: {
            type: String,
            default: 'Category menu '
        },
        isShowBlueLine: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            categories: [
                {
                    name: 'care',
                    icon: 'icons/care-green',
                    color: '#157251'
                },
                {
                    name: 'services',
                    icon: 'icons/service-white',
                    color: '#E25046'
                },
            ]
        }
    },
    computed: {
        mergedData() {
            return this.extras ? [...this.categories, ...this.extras] : this.categories;
        }
    },
    methods: {
        handleClick(data) {
            this.$emit('onMenuClick', data.name);
        }
    }
}
</script>

<style lang="scss">
@import "o-main-category-menu";
</style>